/* eslint-disable react-hooks/rules-of-hooks */
import { WithApolloProps, ApolloContext } from 'next-with-apollo';
import { useIsAuthenticated } from '../providers/Auth';
import withConditionalRedirect from './withConditionalRedirect';

export default function withoutAuth(
	WrappedComponent: {
		({ apollo, apolloState, ...props }: Partial<WithApolloProps<any>>): any;
		displayName: string;
		getInitialProps(pageCtx: ApolloContext<any>): Promise<{}>;
	},
	location = '/general',
) {
	return withConditionalRedirect({
		WrappedComponent,
		location,
		clientCondition: function withoutAuthClientCondition() {
			return useIsAuthenticated();
		},
		serverCondition: function withoutAuthServerCondition(ctx: {
			req: { cookies: { session: any } };
		}) {
			return !!ctx.req?.cookies.session;
		},
	});
}
